(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["eido-faq-master-detail"] && !Shopify.designMode) return;
  try {
    
    (function () {
      var controllers = new WeakMap();
      function init(root) {
      if (controllers.has(root)) return;
      var controller = new AbortController();
      controllers.set(root, controller);
      var signal = controller.signal;

      // If routing mode is links, we still enhance:
      // - prevent full navigation for same-page UX (unless user opens in new tab)
      // - respect ?cat= param on load (SEO-friendly URLs)
      var routingMode = root.dataset.faqRouting;

      var tabs = Array.prototype.slice.call(root.querySelectorAll(".eido-faq__tab"));
      var panels = Array.prototype.slice.call(root.querySelectorAll(".eido-faq__panel"));
      var content = root.querySelector(".eido-faq__content");
      if (!content || !tabs.length || !panels.length) return;

      var defaultKey = root.dataset.faqDefault;

      function prefersReducedMotion() {
        return Boolean(window.EidoMotion?.reduced() || window.matchMedia?.('(prefers-reduced-motion: reduce)').matches);
      }

      function buildKeySet() {
        var s = {};
        for (var i = 0; i < panels.length; i++) s[panels[i].getAttribute("data-panel")] = true;
        return s;
      }
      var keys = buildKeySet();

      function setTabState(activeKey) {
        for (var i = 0; i < tabs.length; i++) {
          var el = tabs[i];
          var k = el.getAttribute("data-faq");
          var isActive = k === activeKey;

          if (isActive) el.classList.add("is-active");
          else el.classList.remove("is-active");

          el.setAttribute("aria-current", isActive ? "page" : "false");
          el.setAttribute("aria-selected", isActive ? "true" : "false");
          el.setAttribute("tabindex", isActive ? "0" : "-1");
        }
      }

      function setPanels(activeKey) {
        for (var i = 0; i < panels.length; i++) {
          var p = panels[i];
          p.hidden = p.getAttribute("data-panel") !== activeKey;
        }
      }

      function scrollActiveIntoView(activeKey) {
        var el = null;
        for (var i = 0; i < tabs.length; i++) {
          if (tabs[i].getAttribute("data-faq") === activeKey) { el = tabs[i]; break; }
        }
        if (!el || !el.scrollIntoView) return;
        try {
          el.scrollIntoView({
            behavior: prefersReducedMotion() ? "auto" : "smooth",
            block: "nearest",
            inline: "center"
          });
        } catch (e) {}
      }

      function updateUrl(activeKey) {
        // Always set hash; in routing mode also keep ?cat= for shareability.
        try {
          var url = new URL(window.location.href);
          url.hash = activeKey ? "#" + activeKey : "";
          if (routingMode === "links") url.searchParams.set("cat", activeKey);
          history.replaceState(null, "", url.toString());
        } catch (e) {}
      }

      function show(activeKey, opts) {
        opts = opts || {};
        if (!keys[activeKey]) activeKey = defaultKey;

        content.setAttribute("aria-busy", "true");
        setTabState(activeKey);
        setPanels(activeKey);
        if (opts.updateUrl) updateUrl(activeKey);
        if (opts.scroll) scrollActiveIntoView(activeKey);
        content.setAttribute("aria-busy", "false");
      }

      // Progressive enhancement
      root.setAttribute("data-enhanced", "true");

      // aria-controls wiring
      for (var i = 0; i < tabs.length; i++) {
        var k = tabs[i].getAttribute("data-faq");
        for (var j = 0; j < panels.length; j++) {
          if (panels[j].getAttribute("data-panel") === k) {
            if (!panels[j].id) panels[j].id = root.id + "-panel-" + k;
            tabs[i].setAttribute("aria-controls", panels[j].id);
            break;
          }
        }
      }

      // click + keyboard (arrow navigation)
      tabs.forEach(function (el) {
        var isLink = el.tagName === "A";

        el.addEventListener("click", function (e) {
          // In link routing mode, keep UX in-page unless user intends navigation (new tab, modifier keys)
          if (isLink) {
            var openInNew = e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button === 1;
            if (openInNew) return;
            e.preventDefault();
          }
          show(el.getAttribute("data-faq"), { updateUrl: true, scroll: true });
        }, { signal: signal });

        el.addEventListener("keydown", function (e) {
          var idx = tabs.indexOf(el);
          if (idx < 0) return;

          var next = -1;
          if (e.key === "ArrowRight" || e.key === "ArrowDown") next = (idx + 1) % tabs.length;
          if (e.key === "ArrowLeft" || e.key === "ArrowUp") next = (idx - 1 + tabs.length) % tabs.length;

          if (next !== -1) {
            e.preventDefault();
            tabs[next].focus();
          }

          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            el.click();
          }
        }, { signal: signal });
      });

      // One-open-at-a-time within a panel (optional)
      panels.forEach(function (panel) {
        panel.addEventListener("toggle", function (e) {
          var d = e.target;
          if (!d || d.tagName !== "DETAILS") return;
          if (!d.open) return;

          var all = Array.prototype.slice.call(panel.querySelectorAll("details.eido-faq__acc"));
          all.forEach(function (other) {
            if (other !== d) other.open = false;
          });
        }, { capture: true, signal: signal });
      });

      // Init selection priority: ?cat= > #hash > default
      var initial = defaultKey;
      try {
        var url = new URL(window.location.href);
        var qcat = (url.searchParams.get("cat") || "").trim().toLowerCase();
        var hash = (url.hash || "").replace("#","").trim().toLowerCase();
        if (keys[qcat]) initial = qcat;
        else if (keys[hash]) initial = hash;
      } catch (e) {}

      show(initial, { updateUrl: false, scroll: true });

      window.addEventListener("hashchange", function () {
        var k = (window.location.hash || "").replace("#", "").trim().toLowerCase();
        if (keys[k]) show(k, { updateUrl: false, scroll: true });
      }, { signal: signal });
      }
      function roots(scope) { return scope.querySelectorAll('.eido-faq[data-faq-routing]'); }
      roots(document).forEach(init);
      document.addEventListener('shopify:section:load', function (event) { roots(event.target).forEach(init); });
      document.addEventListener('shopify:section:unload', function (event) {
        roots(event.target).forEach(function (root) {
          controllers.get(root)?.abort();
          controllers.delete(root);
        });
      });
    })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eido-pieces-counter"] && !Shopify.designMode) return;
  try {
    (()=>{const clamp=(v,min,max)=>Math.max(min,Math.min(max,v));const toI=v=>{const n=parseInt(String(v??"").replace(/[^\d]/g,""),10);return Number.isFinite(n)?n:null};const pickCount=o=>{if(!o||typeof o!=="object")return null;const v=o.count??o.total??o.pieces??o.pieces_left??o.remaining??(o.data&&(o.data.count??o.data.total??o.data.pieces));return toI(v)};const pickUpd=o=>{if(!o||typeof o!=="object")return null;const v=o.lastUpdated??o.last_updated??o.updatedAt??o.updated_at??(o.data&&(o.data.lastUpdated??o.data.updatedAt));return v==null?null:String(v)};const readJson=async r=>{try{return await r.json()}catch{try{const t=await r.text();return JSON.parse(t)}catch{return null}}};const init=el=>{if(!el||el.dataset.eidoPcInit==="1")return;el.dataset.eidoPcInit="1";const valEl=el.querySelector("[data-eido-pc-value]");const srEl=el.querySelector("[data-eido-pc-sr]");const proxy=(el.getAttribute("data-eido-pc-proxy")||"").trim();const cid=(el.getAttribute("data-eido-pc-collection-id")||"").trim();const label=(el.getAttribute("data-eido-pc-label")||"Pieces left").trim();const soldTxt=(el.getAttribute("data-eido-pc-soldout-text")||"SOLD OUT").trim();const refresh=clamp(parseInt(el.getAttribute("data-eido-pc-refresh-ms")||"30000",10)||30000,5000,600000);const threshold=Math.max(0,parseInt(el.getAttribute("data-eido-pc-threshold")||"178",10)||178);const reduced=!!(window.matchMedia&&window.matchMedia("(prefers-reduced-motion: reduce)").matches);let lastCount=null;let lastUpd=null;let etag=null;let inFlight=false;let timer=null;const pulse=c=>{if(c!=null&&c<=0){el.classList.remove("is-pulsing");return}if(reduced){el.classList.remove("is-pulsing");return}el.classList.toggle("is-pulsing",c!=null&&c>0&&c<=threshold)};const setText=(txt,animate)=>{if(!valEl)return;valEl.textContent=txt;if(animate&&!reduced){valEl.classList.remove("is-ticking");void valEl.offsetWidth;valEl.classList.add("is-ticking")}};const setCount=(c,animate)=>{if(c==null||!valEl)return;if(c<=0){lastCount=0;valEl.setAttribute("data-count","0");setText(soldTxt,animate);if(srEl)srEl.textContent=soldTxt;pulse(0);return}if(lastCount===c){pulse(c);return}lastCount=c;valEl.setAttribute("data-count",String(c));setText(String(c),animate);if(srEl)srEl.textContent=`${label} ${c}`;pulse(c)};const buildUrl=()=>{if(!proxy)return null;try{const u=new URL(proxy,window.location.origin);if(cid)u.searchParams.set("collection_id",cid);return u.toString()}catch{return null}};const fetchOnce=async()=>{if(inFlight)return;const u=buildUrl();if(!u)return;inFlight=true;try{const headers={Accept:"application/json"};if(etag)headers["If-None-Match"]=etag;const r=await fetch(u,{credentials:"same-origin",cache:"no-store",keepalive:true,headers});if(r.status===304)return;const e=r.headers.get("ETag");if(e)etag=e;if(!r.ok)return;const j=await readJson(r);if(!j)return;const c=pickCount(j);if(c==null)return;const upd=pickUpd(j);if(lastCount==null){lastUpd=upd;setCount(c,false);return}if(upd){if(lastUpd===upd){pulse(c);setCount(c,false)}else{lastUpd=upd;setCount(c,true)}}else{setCount(c,c!==lastCount)}}catch{}finally{inFlight=false}};const loop=()=>{if(timer)clearTimeout(timer);timer=setTimeout(async()=>{if(document.visibilityState==="visible")await fetchOnce();loop()},refresh)};if(srEl)srEl.textContent=label;fetchOnce();loop();document.addEventListener("visibilitychange",()=>{if(document.visibilityState==="visible")fetchOnce()},{passive:true})};const boot=root=>{(root||document).querySelectorAll("[data-eido-pc]").forEach(init)};document.addEventListener("DOMContentLoaded",()=>boot(document));document.addEventListener("shopify:section:load",e=>boot(e.target))})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    const url=new URL(window.location.href);if(url.hash){document.addEventListener("DOMContentLoaded",()=>{const card=document.getElementById(url.hash.slice(1));if(card){card.scrollIntoView({behavior:"instant"})}},{once:true})}

  } catch(e) { console.error(e); }
})();
})();
